import riot from 'riot';
import './app.tag.html';


const app = riot.mount('app', {
    user: window.user || {}
});

window.app = app;



// WEBPACK FOOTER //
// ./avr_eshop/frontend/apps/home/app.es6